import { createSlice, PayloadAction } from '@reduxjs/toolkit';


const initialState: any = {
  selectedProject: null,
  selectedLayer: null,
  selectedfileName: null,
  selectedPath: null,
  profilerTabsData:null,
};

const profilerSlice = createSlice({
  name: 'ProfilerSlice',
  initialState,
  reducers: {
   
    setProjectName: (state, action: PayloadAction<any>) => {
      state.selectedProject = action.payload;
      state.selectedLayer=null;
      state.selectedfileName=null;
      state.selectedPath=null;
    },
   
    setLayerName: (state, action: PayloadAction<any>) => {
      state.selectedLayer = action.payload;
      state.selectedfileName=null;
      state.selectedPath=null;

    },
    setFileName: (state, action: PayloadAction<any>) => {
      state.selectedfileName = action.payload;
    },
    setPath: (state, action: PayloadAction<any>) => {
      state.selectedPath = action.payload;
    },
   
    setProfilerTabsData: (state, action: PayloadAction<any>) => {
      state.profilerTabsData = action.payload;
    },
  },
});


export const { 
  setProfilerTabsData,
  setPath,
  setFileName,
  setLayerName,
  setProjectName,

} = profilerSlice.actions;


export default profilerSlice.reducer;
